import React, { useState, useEffect, useRef } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import * as moment from 'moment';

export function CronExpressonBuilder(props) {

    const [expression, setExpression] = useState(props.value);
    const [next, setNext] = useState(null);
    const [selectedDays, setSelectedDays] = useState([]);
    const [selectedHour, setSelectedHour] = useState({ name: '00', code: '0' });
    const [selectedMinute, setSelectedMinute] = useState({ name: '00', code: '0' });
    const days = [
        { name: 'Sunday', code: '0' },
        { name: 'Monday', code: '1' },
        { name: 'Tuesday', code: '2' },
        { name: 'Wednesday', code: '3' },
        { name: 'Thursday', code: '4' },
        { name: 'Friday', code: '5' },
        { name: 'Saturday', code: '6' }
    ];

    const hours = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23];
    const minutes = [
        { name: '00', code: '0' },
        { name: '30', code: '30' }
    ];

    useEffect(() => {
        if(props.value){
            const expressionParts = props.value.split(" ");

            const _selectedHour = hours.find(h => h.toString() === expressionParts[1]);
            setSelectedHour({ name: _selectedHour < 10 ? '0' + _selectedHour : '' + _selectedHour, code: '' + _selectedHour });

            setSelectedDays(days.filter(d => (expressionParts[4].split(",").map(i => i.toString())).indexOf(d.code) >= 0 ));
            setSelectedMinute(minutes.find(m => parseInt(m.code,10) === parseInt(expressionParts[0],10)));

            setNext(calculateNext(props.value))
        }
    });

    const updateExpression = (field, value) => {

        try {
            let _days = selectedDays;
            let _hour = selectedHour;
            let _min = selectedMinute;
            if(field === "days") {
                setSelectedDays(value);
                _days = value;
            }
            else if(field === "hour") {
                setSelectedHour(value);
                _hour = value;
            }
            else if(field === "min") {
                setSelectedMinute(value);
                _min = value;
            }

            let _expression = null;
            let _next = null;
            if(_days.length > 0){
                _expression = (`${_min.code} ${_hour.code} * * ${_days.map(d => d.code).join(",")}`);
                _next = calculateNext(_expression);
            }

            setExpression(_expression);
            setNext(_next);
            props.onChange({ expression: _expression, next: _next.toISOString() });
        } catch (error) {
            console.log(error)
        }
    }

    const calculateNext = (exp) => {
        try {
            const CronX = require('cron-converter');
            const cronInstance = new CronX({ timezone: "America/Sao_Paulo" });
            cronInstance.fromString(exp);
            var schedule = cronInstance.schedule();
            return schedule.next();    
        } catch (error) {
            return ""
        }
        
    }

    return <div className="p-grid" style={{padding: "12px", marginTop: '6px', border: "1px solid #ddd"}}>
        <div className="p-col-6"><b>Week Days</b></div>
        <div className="p-col-6"><b>Time</b></div>
        <div className="p-col-6" style={{padding: '6px'}}>
            <MultiSelect value={selectedDays} options={days} onChange={(e) => updateExpression('days', e.value) } optionLabel="name" placeholder="select days" display="chip" />
        </div>
        <div className="p-col-fixed" style={{padding: '6px', nowrap: 'nowrap', width: '80px'}}>
            <Dropdown value={selectedHour} options={hours.map(h => ({ name: h < 10 ? '0' + h : '' + h, code: '' + h }))} onChange={(e) => updateExpression('hour', e.value)} optionLabel="name" style={{width: '80px'}}/>
        </div>
        <div className="p-col" style={{padding: '6px', nowrap: 'nowrap'}}>
            <Dropdown value={selectedMinute} options={minutes} onChange={(e) => updateExpression('min', e.value)} optionLabel="name" style={{width: '80px'}}/>
        </div>
        { false && expression && 
            <>
            <div className="p-col-6"><b>Cron Expression</b></div>
            <div className="p-col-6"><b>Next Execution</b></div>
            <div className="p-col-6">{expression}</div>
            <div className="p-col-6">{next ? moment(next).format("DD/MM/YYYY HH:mm") : ""}</div>
            </>
        }
        
        
    </div>
}